<template>
    <div class="row mt-3">
        <div class="col-12">
            <TitleComponent title="4. Confirmación de compra" subtitle=""></TitleComponent>
        </div>
        <div class="col-12" v-if="! loading">
            <ListadoAbonosComponent :abonos="datos_compradores" :datos_compra="datos_compra" :urls_imprimir="urls_imprimir" @setTotal="setTotal"></ListadoAbonosComponent>
        </div>
        <b-col cols="12" v-if="teatro.activar_referidos && ! renovacion">
            <BuscarReferidoComponent
                @confirmado="aplicarReferido"
            />
        </b-col>
        <b-col cols="12" v-if="teatro.activar_referidos && renovacion && datos_compradores[0].importe_monedero > 0">
            <SaldoMonederoComponent
                :saldo_disponible="datos_compradores[0].importe_monedero"
                :importe="total"
                :descuento_aplicado="datos_compradores[0].descuento_monedero === undefined ? 0 : parseFloat(datos_compradores[0].descuento_monedero)"
                @confirmado="descuentoConfirmado"
                @cancelar="cancelarDescuento"
            />
        </b-col>
        <div class="col-12 mt-3" v-if="!compra_finalizada">
            <div class="row">
                <div class="col-12" v-if="!loading && !error">
                    <Button class="btn-block" :disabled="loading" @click.prevent="procesarCompra">FINALIZAR COMPRA</Button>
                </div>
                <div class="col-12" v-else>
                    <LoaderComponent></LoaderComponent>
                </div>
            </div>
        </div>
        <template v-if="compra_finalizada && !error">
            <div class="col-12 mt-3">
                <div class="alert alert-success" role="alert">
                    Compra finalizada <Button :href="url_factura" target="blank_">IMPRIMIR RECIBO</Button>
                </div>
            </div>
            <div class="col-12 mt-3">
                <Button class="btn-block" @click.prevent="reiniciar">Volver</Button>
            </div>
        </template>
        <template v-if="error && loading == false">
            <div class="col-12 mt-3">
                <div class="alert alert-danger" role="alert">
                    {{ error }}
                </div>
            </div>
            <div class="col-12 mt-3">
                <Button class="btn-block" @click.prevent="reiniciar">Volver</Button>
            </div>
        </template>
    </div>
</template>

<script>
import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
import ListadoAbonosComponent from '@/components/backend/stepper/components/ListadoAbonosComponent';
import BuscarReferidoComponent from './components/BuscarReferidoComponent.vue';
import SaldoMonederoComponent from '../../../frontend/abonos/nuevo/SaldoMonederoComponent.vue';

export default {
    props: ['datos_compradores', 'datos_compra'],
    data() {
        return {
            compra_finalizada: false,
            loading: false,
            urls_imprimir: [],
            url_factura: [],
            error: null,
            referido_id: null,
            total: 0
        }
    },
    methods: {
        procesarCompra() {
            this.loading = true;
            const params = {
                zona_id: this.datos_compradores[0].area.id,
                numero_entradas: this.datos_compradores.length,
                metodo_pago: this.datos_compra.metodo_pago.id,
                datos_compradores: this.datos_compradores,
                referido_id: this.referido_id
            };
            this.$store.dispatch(this.config.getVuexAlias('back.abonados.alta'), params).then(res => {
                this.compra_finalizada = true;
                this.loading = false;
                this.urls_imprimir = res.data.urls_imprimir;
                this.url_factura = res.data.url_factura;
            }).catch(error => {
                this.error = error.response.data.message;
            }).finally(() => this.loading = false);
        },
        reiniciar() {
            this.$emit('reiniciar');
        },
        aplicarReferido(abonado_id) {
            this.referido_id = abonado_id;
        },
        setTotal(total) {
            this.total = total;
        },
        descuentoConfirmado(descuento) {
            this.loading = true;
            this.datos_compradores[0].descuento_monedero = parseFloat(descuento);
            setTimeout(() => {
                this.loading = false;
            }, 100)
        },
        cancelarDescuento() {
            this.loading = true;
            this.datos_compradores[0].descuento_monedero = 0;
            setTimeout(() => {
                this.loading = false;
            }, 100)
        }
    },
    computed: {
        teatro(){
            return this.$store.getters.getTeatro
        },
        renovacion() {
            return this.$route.query.n_abonado_antiguo ? true : false;
        }
    },
    components: {
        TitleComponent, ListadoAbonosComponent, BuscarReferidoComponent, SaldoMonederoComponent
    }
}
</script>
